import { StyledActivity } from './unlabeled-activity.styles';
import { UnlabeledActivityProps } from './unlabeled-activity.types';
export const UnlabeledActivity = ({
  activity
}: UnlabeledActivityProps) => <StyledActivity data-sentry-element="StyledActivity" data-sentry-component="UnlabeledActivity" data-sentry-source-file="unlabeled-activity.tsx">
    <p>
      {activity.source}: {activity.action}
    </p>
  </StyledActivity>;